import React from 'react';
import { CellWithErrorMessagesStyle } from './style';
import { CellData } from '../../types';

const CellWithErrorMessages = ({ value, errorMessages }: CellData) => {
  return (
    <CellWithErrorMessagesStyle>
      <div>{value}</div>
      {errorMessages.map((message, index) => (
        <p key={index} className="error-message">
          {message}
        </p>
      ))}
    </CellWithErrorMessagesStyle>
  );
};
export default CellWithErrorMessages;
